// DIGITAL DATA
export interface IDigitalData {
  page: {
    pageInfo: IDigitalDataPageInfo;
  };
}
export interface IDigitalDataPageInfo {
  pageName: string;
  livello1: string;
  secondolivello: string;
  terzolivello: string;
  quartolivello: string;
  pagetemplate: string;
}

export const setDigitalData = (newValues: { targetKey: keyof IDigitalDataPageInfo; value: string }[]) => {
  const pageInfo: IDigitalDataPageInfo = (window as any).digitalData ? (window as any).digitalData.page.pageInfo : {};
  newValues.forEach(({ targetKey, value }) => (pageInfo[targetKey] = value));
};
